import { Link } from "react-router-dom";
import { Logo } from "@volca/ui/components/ui/logo";

export const PublicHeader = () => (
  <header className="flex h-16 shrink-0 items-center border-b bg-surface-raised px-4 sm:px-6 lg:px-8">
    <Link to="/" aria-label="Volca home">
      <Logo className="h-8 w-auto" />
    </Link>
  </header>
);
